import { useMemo } from 'react'
import { hasPermission } from 'utils/Subscription/RequiredPermissions'
import { IRootReducerState } from 'state/rootReducer'
import { PERMISSION_GARAGE_ADMIN, PERMISSION_ONLY_PORTAL } from 'utils/Subscription/PermissionComposites'
import { useSelector } from 'react-redux'

export const isPortalSelector = (state: IRootReducerState) => {
  return (
    state.auth &&
    state.auth.shop &&
    state.auth.shop.Modules &&
    hasPermission(state.auth.shop.Modules, PERMISSION_ONLY_PORTAL, state.auth.permissionExtension.modifiedPermissions)
  )
}

export const useIsPortal = () => {
  // these selects should happen seperately for performance reasons.
  const modules = useSelector(state => state?.auth?.shop?.Modules)
  const modifiedPermissions = useSelector(state => state.auth?.permissionExtension?.modifiedPermissions)
  return useMemo(() => hasPermission(modules, PERMISSION_ONLY_PORTAL, modifiedPermissions), [modules, modifiedPermissions])
}

const isGarageAdminSelector = (state: IRootReducerState) => {
  return (
    state.auth &&
    state.auth.shop &&
    state.auth.shop.Modules &&
    hasPermission(state.auth.shop.Modules, PERMISSION_GARAGE_ADMIN, state.auth.permissionExtension.modifiedPermissions)
  )
}

export const useIsGarageAdmin = () => useSelector((state: IRootReducerState) => isGarageAdminSelector(state))
